import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

export default function Support() {
  return (
    <div className="home-page">

      {/* NAV */}
      <nav className="home-nav">
        <div className="container d-flex justify-content-between align-items-center">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <span className="nav-logo">Zip<span>QA</span></span>
          </Link>
          <div className="d-flex gap-2 align-items-center">
            <Link to="/support" className="btn-nav-ghost">Support</Link>
            <Link to="/login" className="btn-nav-primary">Sign In</Link>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section style={{ padding: '120px 0 60px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
        <div className="container text-center">
          <div className="hero-badge" style={{ margin: '0 auto 1.4rem' }}>✦ We're here to help</div>
          <h1 style={{ fontSize: '3rem', fontWeight: 800, letterSpacing: '-1px', marginBottom: '1rem' }}>Support</h1>
          <p style={{ fontSize: '1.15rem', opacity: 0.88, maxWidth: 520, margin: '0 auto' }}>
            Have a question, issue, or feedback? Reach out and we'll get back to you as soon as possible.
          </p>
        </div>
      </section>

      {/* CONTACT CARD */}
      <section style={{ padding: '80px 0', background: '#f8fafc' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">

              {/* Email card */}
              <div style={{
                background: 'white',
                borderRadius: 16,
                padding: '48px 40px',
                boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                textAlign: 'center',
                marginBottom: 32,
              }}>
                <div style={{
                  width: 64, height: 64, borderRadius: '50%',
                  background: 'linear-gradient(135deg, #667eea, #764ba2)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 28, margin: '0 auto 24px',
                }}>
                  ✉️
                </div>
                <h3 style={{ fontWeight: 700, marginBottom: 8 }}>Email Support</h3>
                <p style={{ color: '#64748b', marginBottom: 24, lineHeight: 1.7 }}>
                  Send us an email and we'll respond within one business day.
                </p>
                <a
                  href="mailto:support@alphaworksai.com"
                  style={{
                    display: 'inline-block',
                    padding: '12px 32px',
                    background: 'linear-gradient(135deg, #667eea, #764ba2)',
                    color: 'white',
                    borderRadius: 8,
                    fontWeight: 600,
                    textDecoration: 'none',
                    fontSize: '1rem',
                    boxShadow: '0 2px 8px rgba(102,126,234,0.35)',
                    transition: 'all 0.2s',
                  }}
                >
                  support@alphaworksai.com
                </a>
              </div>

              {/* Info cards row */}
              <div className="row g-3">
                <div className="col-6">
                  <div style={{
                    background: 'white', borderRadius: 12, padding: '24px 20px',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)', textAlign: 'center',
                  }}>
                    <div style={{ fontSize: 28, marginBottom: 8 }}>⚡</div>
                    <div style={{ fontWeight: 700, marginBottom: 4 }}>Response Time</div>
                    <div style={{ color: '#64748b', fontSize: '0.9rem' }}>Within 1 business day</div>
                  </div>
                </div>
                <div className="col-6">
                  <div style={{
                    background: 'white', borderRadius: 12, padding: '24px 20px',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)', textAlign: 'center',
                  }}>
                    <div style={{ fontSize: 28, marginBottom: 8 }}>🌍</div>
                    <div style={{ fontWeight: 700, marginBottom: 4 }}>Coverage</div>
                    <div style={{ color: '#64748b', fontSize: '0.9rem' }}>Mon – Fri, 9am–6pm IST</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="container">
          <div className="footer-bottom" style={{ borderTop: 'none', paddingTop: 0 }}>
            <p>© 2026 ZipQA by AlphaworksAI. All rights reserved. · <a href="mailto:support@alphaworksai.com" style={{ color: '#a5b4fc' }}>support@alphaworksai.com</a></p>
          </div>
        </div>
      </footer>

    </div>
  );
}
